<script lang="ts" setup>
import { Screen } from 'quasar'
import { clickOnElement } from '~/utils'

const btnSizeByScreen = computed(() => Screen.xs ? 'md' : 'lg')
function clickHandler() {
  clickOnElement('.primary-connect-btn')
}
</script>

<template>
  <div class="wallet-not-connected">
    <div class="wallet-not-connected__body">
      <i-app-wallet-off />

      <span data-name="title" class="text-sm">Wallet disconnected</span>
      <span data-name="desc" class="text-sm">Connect your wallet to view and manage your stake accounts.</span>
    </div>
    <div class="wallet-not-connected__action square-block">
      <app-btn
        class="connect-btn"
        variant="outline"
        :size="btnSizeByScreen"
        @click="clickHandler"
      >
        Connect your wallet
      </app-btn>
    </div>
  </div>
</template>

<style lang="scss">
.wallet-not-connected {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;
  padding-top: 28px;

  &__body {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 32px;
    gap: 32px;

    svg {
      width: 48px;
      height: 48px;
      color: $black;
      margin-bottom: 28px;
    }

    span[data-name='title'] {
      font-size: 18px;
      font-weight: 700;
    }

    span[data-name='desc'] {
      font-size: 16px;
      font-weight: 500;
      max-width: 250px;
    }
  }

  .connect-btn {
    width: 210px;
    min-height: 44px;

    @media (max-width: $breakpoint-xs) {
      min-width: 100px;
      min-height: 32px;
    }
  }
}
</style>
